import styled from 'styled-components'

export const NavContainer = styled.nav`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 30px 14px 30px;
  background-color: ${props => (props.darkMode ? '#212121' : 'white')};
`

export const LogoImg = styled.img`
  width: 12%;
  min-width: 130px;
`

export const ThemeProfileContainer = styled.div`
  display: flex;
  align-items: center;
`

export const ProfileImg = styled.img`
  width: 34px;
  margin-right: 20px;
`

export const LogoutBtn = styled.button`
  background-color: transparent;
  border: 1px solid #3b82f6;
  color: #3b82f6;
  cursor: pointer;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  outline: none;
`

export const PopupContentContainer = styled.div`
  padding: 18px;
  border-radius: 12px;
  background-color: ${props => (props.darkMode ? '#231f20' : '#f8fafc')};
  text-align: center;
  width: 320px;
`

export const LogoutWarning = styled.p`
  color: ${props => (props.darkMode ? '#f1f1f1' : '#231f20')};
`

export const CancelBtn = styled(LogoutBtn)`
  border-color: #94a3b8;
  color: #94a3b8;
  margin-right: 14px;
`

export const ConfirmBtn = styled(LogoutBtn)`
  background-color: #3b82f6;
  color: white;
`

export const ThemeBtn = styled.button`
  background-color: transparent;
  border-width: 0;
  font-size: 26px;
  cursor: pointer;
  margin-right: 20px;
  outline: none;
  color: ${props => (props.darkMode ? '#f1f1f1' : '#181818')}; ;
`
